// extracted by mini-css-extract-plugin
module.exports = {"base":"skeleton-module--base--1JGN-","active":"skeleton-module--active--2S_PW","skeleton":"skeleton-module--skeleton--3aJx4"};